module.exports = __webpack_public_path__ + "img/qukuailian_list2.c71916b2.png";